import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { COLORS } from "../../constants";
import MerchContent from "./MerchContent";

const MobileMerchandising = ({
  categories,
  selectedCategory,
  handleCategorySelect,
}) => (
  <Grid container spacing={1} sx={{ flexDirection: "column", my: 1 }}>
    <Grid item xs={12}>
      <Box sx={{ borderRadius: "2px" }}>
        <Typography
          sx={{
            fontSize: "var(--font-size-l)",
            fontWeight: 500,
            lineHeight: "var(--spacing-xxl)",
            color: COLORS.darkText,
          }}
        >
          Argus Motoring Merchandising
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: COLORS.lightText,
            mb: 2,
            lineHeight: 1.8,
            mt: 1,
            fontSize: "var(--font-size-xxs)",
          }}
        >
          We’re excited to announce the arrival of our brand-new BETA range –
          your one-stop solution for quality reliable general spares.
        </Typography>

        {/* Horizontal Scrollable Category Buttons */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            mt: 3,
            mb: 4,
            width: "100%",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            "-webkit-overflow-scrolling": "touch",
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
          }}
        >
          {categories.map((category) => (
            <Button
              key={category.title}
              onClick={() => handleCategorySelect(category.title)}
              sx={{
                backgroundColor:
                  selectedCategory === category.title
                    ? COLORS.themeRed
                    : COLORS.white,
                borderRadius: "99px",
                color:
                  selectedCategory === category.title
                    ? COLORS.white
                    : COLORS.gray,
                border:
                  selectedCategory === category.title
                    ? "none"
                    : `1px solid ${COLORS.border}`,
                px: 4,
                py: 1,
                flexShrink: 0,
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor:
                    selectedCategory === category.title
                      ? COLORS.themeRed
                      : COLORS.border,
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "var(--font-size-xxs)",
                  textAlign: "center",
                }}
              >
                {category.title}
              </Typography>
            </Button>
          ))}
        </Box>
      </Box>
    </Grid>

    {/* Content Area */}
    <Grid item xs={12} md={8.2}>
      <MerchContent selectedCategory={selectedCategory} />
    </Grid>
  </Grid>
);

export default MobileMerchandising;
